export default __webpack_public_path__ + "static/media/logo.450d19d4.png";